import React from 'react';
import '../../../styles/pages/tara/taraUI/taraHeading.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const TaraHeading = () => {
  const { t } = useTranslation();

  const userFirstName = useSelector(
    (state: RootState) => state.user.profile.first_name
  );

  const initialHeading = () => {
    return (
      <div className='taraHeading__initial'>
        {userFirstName && userFirstName !== '' && (
          <h3>{`Hi ${userFirstName},`}</h3>
        )}
        <h1>{t('What can I help you with?')}</h1>

        {/* <TaraBasicButton
          onClick={() => {}}
          value={t('Setup notification rules')}
          type='button'
          buttonUse='yellow'
          icon={bellSVG}
        /> */}
      </div>
    );
  };

  return <>{initialHeading()}</>;
};

export default TaraHeading;
